import { Field } from '@/shared/ui/field'
import { Select } from '@/shared/ui/select'

export interface CompanyProjectValue {
  companyId: string
  projectId: string
}

export interface CompanyProjectOption {
  id: string
  name: string
}

interface CompanyProjectFieldsProps {
  value: CompanyProjectValue
  onChange: (value: CompanyProjectValue) => void
  companies: CompanyProjectOption[]
  // Проекты выбранной компании; вызывающий грузит их сам (справочники — слой
  // entities, до которого shared не дотягивается).
  projects: CompanyProjectOption[]
  companiesLoading?: boolean
  projectsLoading?: boolean
  error?: string | undefined
}

// Пикер привязки звонка к хабу: компания и проект выбираются из справочника.
// Инвариант «project требует company» зеркалим — проект недоступен, пока не
// выбрана компания, а смена компании снимает проект, который к ней не относится.
export function CompanyProjectFields({
  value,
  onChange,
  companies,
  projects,
  companiesLoading = false,
  projectsLoading = false,
  error,
}: CompanyProjectFieldsProps) {
  return (
    <div className="flex flex-col gap-4">
      <Field label="Компания" hint="Пусто — внутренняя встреча">
        {(p) => (
          <Select
            {...p}
            value={value.companyId}
            disabled={companiesLoading}
            placeholder={companiesLoading ? 'Загружаем…' : 'Без компании'}
            options={companies.map((c) => ({ value: c.id, label: c.name }))}
            // Смена компании снимает проект: он принадлежит прежней компании.
            onChange={(companyId) => onChange({ companyId, projectId: '' })}
          />
        )}
      </Field>
      <Field
        label="Проект"
        hint="Доступен только при выбранной компании"
        {...(error ? { error } : {})}
      >
        {(p) => (
          <Select
            {...p}
            value={value.projectId}
            disabled={!value.companyId || projectsLoading}
            placeholder={
              !value.companyId
                ? 'Сначала выберите компанию'
                : projectsLoading
                  ? 'Загружаем…'
                  : 'Без проекта'
            }
            options={(value.companyId ? projects : []).map((pr) => ({
              value: pr.id,
              label: pr.name,
            }))}
            onChange={(projectId) => onChange({ ...value, projectId })}
          />
        )}
      </Field>
    </div>
  )
}
